import type { GetLinkedItemAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import { GetLinkedItemAuditDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetLinkedItemAuditByIdArgs = { id: string };

export const useGetLinkedItemAuditById = createQueryHook<
  UseGetLinkedItemAuditByIdArgs,
  GetLinkedItemAuditByIdResponseRow[],
  AuditLogQueryResult<
    'risksmart_linked_item_audit',
    GetLinkedItemAuditByIdResponseRow
  >
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getLinkedItemAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ risksmart_linked_item_audit: data }),
  graphqlDocument: GetLinkedItemAuditDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
